// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-border[data-v-38e2f303] {\n  border-top: 8px solid white;\n  border-right: 8px solid white;\n  border-bottom: 1px solid #e5e7eb;\n}", ""]);
// Exports
module.exports = exports;
